// ==========================================
// ルート定義
// ==========================================

export const ROUTES = {
  // 認証
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CONFIRM_EMAIL: '/confirm-email',

  // ダッシュボード
  HOME: '/',
  DASHBOARD: '/',
  ONBOARDING: '/onboarding',

  // 通知
  NOTIFICATIONS: '/notifications',

  // ドメイン
  DOMAINS: '/chatbots',
  DOMAIN_NEW: '/chatbots/new',
  DOMAIN_DETAIL: '/chatbots/:id',
  DOMAIN_DISCOVER: '/chatbots/:id/discover',
  DOMAIN_CHAT_HISTORY: '/chatbots/:id/history',

  // サブスクリプション
  SUBSCRIPTION: '/subscription',

  // 設定
  SETTINGS: '/settings',
  SETTINGS_WITHDRAWAL: '/settings/withdrawal',

  // お問い合わせ
  CONTACT: '/contact',

  // リード
  LEADS: '/leads',

  // FAQ
  FAQ: '/faq',

  // 管理者
  ADMIN_USERS: '/admin/users',

} as const;

// 認証不要のルート
export const PUBLIC_ROUTES = [
  ROUTES.LOGIN,
  ROUTES.SIGNUP,
  ROUTES.FORGOT_PASSWORD,
  ROUTES.RESET_PASSWORD,
  ROUTES.CONFIRM_EMAIL,
];

// パスからドメインIDを取得
export const getDomainIdFromPath = (path: string): string | null => {
  const match = path.match(/\/chatbots\/([^/]+)/);
  return match ? match[1] : null;
};

export const getDomainDetailPath = (id: string) => ROUTES.DOMAIN_DETAIL.replace(':id', id);
export const getDomainDiscoverPath = (id: string) => ROUTES.DOMAIN_DISCOVER.replace(':id', id);
export const getDomainChatHistoryPath = (id: string) => ROUTES.DOMAIN_CHAT_HISTORY.replace(':id', id);
